import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutProspectType extends Layout {
    sourceProspectType: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
